import { createFeatureSelector, createSelector } from '@ngrx/store';

import { StoreAvailableAdjustmentRequestState } from './store-available-adjustment-request.reducers';

export const selectStoreAvailableAdjustmentRequestState = createFeatureSelector<StoreAvailableAdjustmentRequestState>(
  'storeAvailableAdjustmentRequest'
);

export const selectAllStoreAvailableAdjustmentRequestList = createSelector(
  selectStoreAvailableAdjustmentRequestState,
  (state: StoreAvailableAdjustmentRequestState) => {
    return state.selected;
  }
);

export const selectStoreAvailableAdjustmentRequestListCriteria = createSelector(
  selectStoreAvailableAdjustmentRequestState,
  state => {
    return state.criteriaObject;
  }
);

export const selectStoreAvailableAdjustmentRequestResponse = createSelector(
  selectStoreAvailableAdjustmentRequestState,
  (state: StoreAvailableAdjustmentRequestState) => {
    return state.viewStoreAvailableAdjustmentRequest;
  }
);
